import { Injectable } from "@angular/core";

import { from, of } from 'rxjs';
import { catchError, map, mergeMap, tap } from 'rxjs/operators';

import { Actions, createEffect, ofType } from "@ngrx/effects";

import { fetchPestampsListData, fetchPestampsListSuccess, fetchPestampsListFailure, addPestampData, addPestampDataSuccess, addPestampDataFailure, fetchSinglePestampRecordData, fetchSinglePestampRecordDataSuccess, fetchSinglePestampRecordDataFailure, updatePestampStatus, updatePestampStatusSuccess, updatePestampStatusFailure, fetchPestampRecordComments, fetchPestampRecordCommentsFailure, fetchPestampRecordCommentsSuccess, fetchPestampRecordRevisions, fetchPestampRecordRevisionsSuccess, fetchPestampRecordRevisionsFailure, fetchPestampRecordholdunhold, fetchPestampRecordholdunholdSuccess, fetchPestampRecordholdunholdFailure, createHoldRecord, createHoldRecordFailure, createHoldRecordSuccess, createRevisionRecord, createRevisionRecordSuccess, createRevisionRecordFailure, createPestampCommentRecord, createPestampCommentRecordSuccess, createPestampCommentRecordFailure, fetchPestampMembersList, fetchPestampMembersListFailure, fetchPestampMembersListSuccess, fetchPestampCancelReasonsList, fetchPestampCancelReasonsListSuccess, fetchPestampCancelReasonsListFailure, cancelPestampRecord, cancelPestampRecordSuccess, cancelPestampRecordFailure, fetchPestampAttachments, fetchPestampAttachmentsSuccess, fetchPestampAttachmentsFailure, editPestampData, editPestampDataSuccess, editPestampDataFailure, releasePestampRecord, releasePestampRecordSuccess, releasePestampRecordFailure, fetchPestampFileAttachment, fetchPestampFileAttachmentSuccess, fetchPestampFileAttachmentFailure, createPestampReviewCommentRecord, createPestampReviewCommentRecordFailure, createPestampReviewCommentRecordSuccess, deleteRevisionRecord, deleteRevisionRecordSuccess, deleteRevisionRecordFailure } from "./pestamp.actions";
import { PestampService } from "../../core/services/pestamp.service";
import { AngularFirestore } from "@angular/fire/compat/firestore";
import { TokenStorageService } from '../../core/services/token-storage.service';
import { ToastifyService } from "../../shared/toastify-service";
import { Router } from "@angular/router";
import { PestampModel } from "../../core/models/pestamp.models";
import { GenericService } from "../../core/services/generic.service";
import { CommonAPIService } from "../../core/services/common-api.service";
import { GlobalComponent } from "../../global-component";
import { collection, collectionData, query, where, and, or, onSnapshot, QueryConstraint, QueryCompositeFilterConstraint, orderBy } from '@angular/fire/firestore';
import { FiltersService } from "../../core/services/filters.service";


@Injectable()
export class PestampEffects {

  currentuser: any;
  firbasebasecollname: string = 'vendors';
  subdomaincollname: string = 'subdomains';
  vendorguid!: string;

  // checkcondition(ref: any, tabId: number) {
  //   this.currentuser = this.tokenService.getUser();
  //   let isuservendor = this.genericService.getUserIsVendor();
  //   let activestateval = true;
  //   if(tabId == 6){
  //     activestateval = false;
  //   }
  //   let baseQuery = ref.where('activestate', '==', activestateval);

  //   if (!this.currentuser.usertype || !isuservendor) {
  //     baseQuery = baseQuery.where('clientguid', '==', this.currentuser.role?.type === 'super_admin' ? this.currentuser.guid : this.currentuser.masterguid);
  //   }

  //   switch (tabId) {
  //     case 1:
  //       if (isuservendor) {
  //         if(this.currentuser.isprelimuser){

  //         }

  //         if(this.currentuser.isproductionuser){
  //           return or(and(where('jobstatus', 'in', ['accepted']), where('isprelimrequired', '==', false)),where('jobstatus', 'in', ['auroracompleted']))
  //         }
  //         return baseQuery.where('jobstatus', 'in', ['outsourced', 'accepted', 'picked']).where('isinrevisionstate', '==', false);
  //       } else {
  //         return baseQuery.where('jobstatus', 'in', ['created', 'outsourced', 'accepted', 'picked']).where('isinrevisionstate', '==', false);
  //       }
  //     case 2:
  //       return baseQuery.where('isinrevisionstate', '==', true).where('jobstatus', '==', 'accepted');
  //     case 3:
  //       return baseQuery.where('jobstatus', '==', 'hold');
  //     case 4:
  //       return baseQuery.where('jobstatus', 'in', ['auroraassigned', 'auroracompleted', 'productionassigned', 'productioncompleted', 'reviewassigned', 'reviewpassed', 'reviewfailed']);
  //     case 5:
  //       return baseQuery.where('jobstatus', '==', 'delivered');
  //     case 6:
  //       return baseQuery;
  //     default:
  //       return baseQuery;
  //   }
  // }

  async checkCondition(tabId: number) {
    this.currentuser = this.tokenService.getUser();
    const isuservendor = this.genericService.getUserIsVendor();
    const vendorCollection = collection(this.afs.firestore, `${this.firbasebasecollname}/${this.tokenService.getVendorGUID()!}/pestamps`);
    let activestateval = true;
    if (tabId == 6) {
      activestateval = false;
    }

    let isclient = false, isstampinguser = false, isqcuser = false;
    if (!isuservendor) {
      if (this.currentuser.usertype == 'client') {
        isclient = true;
      } else if (this.currentuser.usertype == 'stampingpartner') {
        isstampinguser = true;
      } 
    }
    
    let baseQuery = and(where('activestate', '==', activestateval));
    // Adding Filter Queries to baseQuery

    const filterData: any = this.filtersService.getPestampsSelectedFilters()

    if (filterData.clients && filterData.clients.length) {
      baseQuery = and(baseQuery, where("clientguid", 'in', filterData.clients))
    }

    if (filterData.jobtypes && filterData.jobtypes.length) {
      baseQuery = and(baseQuery, where("jobtype", "in", filterData.jobtypes))
    }

    if (filterData.states && filterData.states.length) {
      baseQuery = and(baseQuery, where("state", "in", filterData.states))
    }

    if (filterData.propertytypes && filterData.propertytypes.length) {
      baseQuery = and(baseQuery, where("propertytype", "in", filterData.propertytypes))
    }

    if (filterData.stampingtypes && filterData.stampingtypes.length) {
      baseQuery = and(baseQuery, where("stampingtype", "in", filterData.stampingtypes))
    }

    if (filterData.statuses && filterData.statuses.length) {
      baseQuery = and(baseQuery, where("jobstatus", "in", filterData.statuses))
    }
    if (filterData.daterange && filterData.daterange.length) {
      let queryby = ""
      switch (tabId) {
        case 1:
          queryby = "createdAt"
          break
        case 2:
          queryby = "revisiondate"
          break
        case 3:
          queryby = "onholddate"
          break
        case 5:
          queryby = "deliverydate"
          break
        default:
          queryby = "createdAt"
      }
      let startDate = new Date(filterData.daterange[0].setHours(0, 0, 0, 0))
      let endDate = new Date(filterData.daterange[0].setHours(23, 59, 59, 999))


      if (filterData.daterange.length === 2) {
        endDate = new Date(filterData.daterange[1].setHours(23, 59, 59, 999))

      }

      baseQuery = and(baseQuery, where(queryby, ">=", startDate.toISOString()), where(queryby, "<=", endDate.toISOString()))
    }
    const userRoleCondition = where('clientguid', '==', this.currentuser.role?.type === 'super_admin' ? this.currentuser.guid : this.currentuser.masterguid);
    let userRoleQuery: any = baseQuery;
    let memberQuery: QueryCompositeFilterConstraint | null = null;

    if (!this.currentuser.usertype || (!isuservendor && !isstampinguser)) {
      userRoleQuery = and(userRoleCondition, baseQuery) as QueryCompositeFilterConstraint;
    }

    switch (tabId) {
      case 1:
        if (this.currentuser.isstampingengineer) {
          memberQuery = and(userRoleQuery, where('jobstatus', '==', 'stampingpartneraccepted'));
        }

        if (memberQuery) {
          console.log("member query...");
          return query(vendorCollection, memberQuery, orderBy("createdAt", "desc"));
        }

        if (isclient) {
          console.log("is client test");
          return query(vendorCollection, and(userRoleQuery, where('jobstatus', 'in', ['created', 'outsourced', 'accepted', 'picked', 'stampingpartnerassigned', 'stampingpartneraccepted', 'stampingpartnerpicked']), where('isinrevisionstate', '==', false)), orderBy("createdAt", "desc"));
        }

        if (isstampinguser) {
          console.log('test...', this.currentuser.guid)
          return query(vendorCollection, and(userRoleQuery, where('jobstatus', 'in', ['stampingpartnerassigned', 'stampingpartneraccepted', 'stampingpartnerpicked']), where('isinrevisionstate', '==', false), where('stampingpartnerguid', '==', this.currentuser.guid)), orderBy("createdAt", "desc"));
        }

        if (this.currentuser.isqcuser){
          console.log('test 333');
          return query(vendorCollection, and(userRoleQuery, where('jobstatus', 'in', ['stampingengineercompleted' ])), orderBy("createdAt", "desc"));
        }

        console.log('test 1...');
        return query(vendorCollection, and(userRoleQuery, where('jobstatus', 'in', ['outsourced', 'accepted', 'picked', 'stampingpartnerassigned', 'stampingpartneraccepted', 'stampingpartnerpicked']), where('isinrevisionstate', '==', false)), orderBy("createdAt", "desc"));

      case 2:
        if (isstampinguser) {
          return query(vendorCollection, and(userRoleQuery, where('isinrevisionstate', '==', true), where('jobstatus', '==', 'stampingpartneraccepted'), where('stampingpartnerguid', '==', this.currentuser.guid)), orderBy("revisiondate", "desc"));
        }

        return query(vendorCollection, and(userRoleQuery, where('isinrevisionstate', '==', true), where('jobstatus', '==', 'stampingpartneraccepted')), orderBy("revisiondate", "desc"));

      case 3:
        if (isstampinguser) {
          return query(vendorCollection, and(userRoleQuery, where('jobstatus', '==', 'hold'), where('stampingpartnerguid', '==', this.currentuser.guid)), orderBy("onholddate", "desc"));
        }
        return query(vendorCollection, and(userRoleQuery, where('jobstatus', '==', 'hold')), orderBy("onholddate", "desc"));

      case 4:
        memberQuery = null;
        if (this.currentuser.isstampingengineer) {
          memberQuery = or(and(where('jobstatus', 'in', ['stampingengineercompleted', 'reviewassigned', 'reviewfailed']), where('stampingengineerguid', '==', this.currentuser.guid)), and(userRoleQuery, where('jobstatus', 'in', ['stampingengineerassigned']), where('activeuserguid', '==', this.currentuser.guid)));
        }

        if (memberQuery) {
          return query(vendorCollection, memberQuery, orderBy("createdAt", "desc"));
        }

        if (isstampinguser) {
          return query(vendorCollection, and(userRoleQuery, where('jobstatus', 'in', ['stampingengineerassigned', 'stampingengineercompleted', 'reviewassigned', 'reviewfailed']), where('stampingpartnerguid', '==', this.currentuser.guid)), orderBy("createdAt", "desc"));
        }

        if (this.currentuser.isqcuser) {
          console.log('test 333');
          return query(vendorCollection, and(userRoleQuery, where('jobstatus', 'in', ['reviewassigned', 'reviewfailed'])), orderBy("createdAt", "desc"));
        }
        return query(vendorCollection, and(userRoleQuery, where('jobstatus', 'in', ['stampingengineerassigned', 'stampingengineercompleted', 'reviewassigned', 'reviewfailed'])), orderBy("createdAt", "desc"));

      case 5:
        memberQuery = null;
        console.log("stampinguserguid...", this.currentuser.guid);
        if (this.currentuser.isstampingengineer) {
          memberQuery = and(where('jobstatus', '==', 'delivered'), where('stampingengineerguid', '==', this.currentuser.guid), where('isarchived', '==', false));
        }

        if (memberQuery) {
          console.log("delivery memberQuery...", memberQuery);
          return query(vendorCollection, memberQuery, orderBy("deliverydate", "desc"));
        }

        if (isstampinguser) {
          return query(vendorCollection, and(userRoleQuery, where('jobstatus', '==', 'delivered'), where('stampingpartnerguid', '==', this.currentuser.guid), where('isarchived', '==', false)), orderBy("deliverydate", "desc"));
        }

        return query(vendorCollection, and(userRoleQuery, and(where('jobstatus', '==', 'delivered'), where('isarchived', '==', false))), orderBy("deliverydate", "desc"));

      case 6:
        if (isstampinguser) {
          return query(vendorCollection, and(userRoleQuery, where('activestate', '==', activestateval), where('stampingpartnerguid', '==', this.currentuser.guid)), orderBy("cancelleddate", "desc"));
        }
        return query(vendorCollection, userRoleQuery, orderBy("cancelleddate", "desc"));

      default:
        console.log('Invalid tabId:', tabId);
        return query(vendorCollection, baseQuery, orderBy("createdAt", "desc"));
    }
  }


  /**
   * FOR VENDOR
   */
  // Pestamp Fresh List Effect Of Vendor
  fetchPestampData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchPestampsListData),
      mergeMap(({ tabId }) =>
        from(this.checkCondition(tabId)).pipe(
          mergeMap(condition =>
            collectionData(condition).pipe(
              map((docs: any) => {
                console.log("docs", docs);
                console.log("tabId", tabId);
                const pestamps = docs.map((doc: PestampModel) => doc);
                return fetchPestampsListSuccess({ Pestamps: pestamps, tabid: tabId });
              }),
              catchError((error) =>
                of(fetchPestampsListFailure({ error, tabid: tabId }))
              )
            )
          )
        )
      )
    )
  );



  // Create Pestamp Record
  addPestampData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(addPestampData),
      mergeMap(({ postdata }) =>
        this.pestampService.addPestampsData(postdata).pipe(
          map((pestamprecord) => addPestampDataSuccess(pestamprecord)),
          catchError((error) => of(addPestampDataFailure({ error })))
        )
      ),
    ),
  );

  addPestampDataSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(addPestampDataSuccess),
        tap((user: any) => {
          this.toastifyService.showSuccessMessage("Order created successfully");
        })
      ),
    { dispatch: false }
  );

  addPestampDataFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(addPestampDataFailure),
        tap((error: any) => {
          this.toastifyService.showErrorMessage(error.error.message);
        })
      ),
    { dispatch: false }
  );

  // Fetch Pestamp Record
  fetchSinglePestampRecordData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchSinglePestampRecordData),
      mergeMap(({ recordguid }) =>
        this.pestampService.getPestampsRecordData(recordguid).pipe(
          map((pestamprecord) => fetchSinglePestampRecordDataSuccess({ pestamprecord })),
          catchError((error) => of(fetchSinglePestampRecordDataFailure({ error })))
        )
      ),
    ),
  );

  // Fetch Pestamp Record
  updatePestampStatus$ = createEffect(() =>
    this.actions$.pipe(
      ofType(updatePestampStatus),
      mergeMap(({ recordguid, postdata }) =>
        this.pestampService.updatePestampStatus(recordguid, postdata).pipe(
          map(() => updatePestampStatusSuccess()),
          catchError((error) => of(updatePestampStatusFailure({ error })))
        )
      ),
    ),
  );

  // Fetch Pestamp Record
  updatePestampStatusSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(updatePestampStatusSuccess),
        tap(() => {
          this.toastifyService.showSuccessMessage("Order updated successfully");
          // this.router.navigate(['../']);
        })
      ),
    { dispatch: false }
  );

  updatePestampStatusFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(updatePestampStatusFailure),
        tap((error: any) => {
          this.toastifyService.showErrorMessage(error.error.message);
        })
      ),
    { dispatch: false }
  );

  // Fetch Pestamp Comments Record
  fetchPestampRecordComments$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchPestampRecordComments),
      mergeMap(({ recordguid }) =>
        this.commonService.fetchRecords('pestampcomments', recordguid, 'createdAt:DESC').pipe(
          map((comments) => fetchPestampRecordCommentsSuccess({ comments: comments })),
          catchError((error) => of(fetchPestampRecordCommentsFailure({ error })))
        )
      ),
    ),
  );

  fetchPestampRecordCommentsFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fetchPestampRecordCommentsFailure),
        tap((error: any) => {
          this.toastifyService.showErrorMessage(error.error.message);
        })
      ),
    { dispatch: false }
  );

  // Fetch Pestamp Revisions Record
  fetchPestampRecordRevisions$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchPestampRecordRevisions),
      mergeMap(({ recordguid }) =>
        this.commonService.fetchRecords('pestamprevisionjobs', recordguid, 'createdAt:DESC').pipe(
          map((revisions) => fetchPestampRecordRevisionsSuccess({ revisions: revisions })),
          catchError((error) => of(fetchPestampRecordRevisionsFailure({ error })))
        )
      ),
    ),
  );

  fetchPestampRecordRevisionsFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fetchPestampRecordRevisionsFailure),
        tap((error: any) => {
          this.toastifyService.showErrorMessage(error.error.message);
        })
      ),
    { dispatch: false }
  );

  // Fetch Pestamp Hold/Unhold Record
  fetchPestampRecordholdunhold$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchPestampRecordholdunhold),
      mergeMap(({ recordguid }) =>
        this.commonService.fetchRecords('pestampholdjobs', recordguid, 'createdAt:DESC').pipe(
          map((holdunholdrecords) => fetchPestampRecordholdunholdSuccess({ holdunhold: holdunholdrecords })),
          catchError((error) => of(fetchPestampRecordholdunholdFailure({ error })))
        )
      ),
    ),
  );

  fetchPestampRecordholdunholdFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fetchPestampRecordholdunholdFailure),
        tap((error: any) => {
          this.toastifyService.showErrorMessage(error.error.message);
        })
      ),
    { dispatch: false }
  );

  // HOLD RECORD CREATE
  createHoldRecord$ = createEffect(() =>
    this.actions$.pipe(
      ofType(createHoldRecord),
      mergeMap(({ postdata }) =>
        this.commonService.createRecords('pestampholdjobs', postdata).pipe(
          map((holdrecord: any) => createHoldRecordSuccess({ holdrecord })),
          catchError((error) => of(createHoldRecordFailure({ error })))
        )
      ),
    ),
  );

  createHoldRecordSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(createHoldRecordSuccess),
        tap(() => {
          this.toastifyService.showSuccessMessage(GlobalComponent.messages.holdsuccess);
        })
      ),
    { dispatch: false }
  );

  createHoldRecordFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(createHoldRecordFailure),
        tap((error: any) => {
          this.toastifyService.showErrorMessage(error.error.message);
        })
      ),
    { dispatch: false }
  );

  // HOLD RECORD CREATE
  createRevisionRecord$ = createEffect(() =>
    this.actions$.pipe(
      ofType(createRevisionRecord),
      mergeMap(({ postdata }) =>
        this.commonService.createRecords('pestamprevisionjobs', postdata).pipe(
          map((revisionrecord) => createRevisionRecordSuccess({ revisionrecord })),
          catchError((error) => of(createRevisionRecordFailure({ error })))
        )
      ),
    ),
  );

  createRevisionRecordSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(createRevisionRecordSuccess),
        tap(() => {
          this.toastifyService.showSuccessMessage(GlobalComponent.messages.holdsuccess);
        })
      ),
    { dispatch: false }
  );

  createRevisionRecordFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(createRevisionRecordFailure),
        tap((error: any) => {
          this.toastifyService.showErrorMessage(error.error.message);
        })
      ),
    { dispatch: false }
  );

  // COMMENT CREATE
  createPestampCommentRecord$ = createEffect(() =>
    this.actions$.pipe(
      ofType(createPestampCommentRecord),
      mergeMap(({ postdata }) =>
        this.commonService.createRecords('pestampcomments', postdata).pipe(
          map((comment) => createPestampCommentRecordSuccess({ comment })),
          catchError((error) => of(createPestampCommentRecordFailure({ error })))
        )
      ),
    ),
  );

  // Fetch Pestamp Comments Record
  fetchPestampMembersList$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchPestampMembersList),
      mergeMap(({ recordguid }) =>
        this.pestampService.getPestampsMembersList(recordguid).pipe(
          map((list) => fetchPestampMembersListSuccess({ memberslist: list })),
          catchError((error) => of(fetchPestampMembersListFailure({ error })))
        )
      ),
    ),
  );

  fetchPestampMembersListFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fetchPestampMembersListFailure),
        tap((error: any) => {
          this.toastifyService.showErrorMessage(error.error.message);
        })
      ),
    { dispatch: false }
  );

  createPestampCommentRecordFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(createPestampCommentRecordFailure),
        tap((error: any) => {
          this.toastifyService.showErrorMessage(error.error.message);
        })
      ),
    { dispatch: false }
  );

  // FETCH CANCEL REASONS FROM FIREBASE
  fetchPestampCancelReasonsList$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchPestampCancelReasonsList),
      mergeMap(() =>
        this.afs.collection(GlobalComponent.firebasecancelreasonsbasecollname).doc('JnlKZBhKuN2yOmSiptTb')
          .valueChanges().pipe(
            map((docs: any) => {
              console.log(":docs", docs)
              return fetchPestampCancelReasonsListSuccess({ reasons: docs });
            }),
            catchError((error) =>
              of(fetchPestampCancelReasonsListFailure({ error }))
            )
          )
      ),
    ),
  );

  fetchPestampCancelReasonsListFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fetchPestampCancelReasonsListFailure),
        tap((error: any) => {
          this.toastifyService.showErrorMessage(error.error ? error.error.message : 'something went wrong, please check again');
        })
      ),
    { dispatch: false }
  );

  // CANCEL PESTAMP PROJECT
  cancelPestampRecord$ = createEffect(() =>
    this.actions$.pipe(
      ofType(cancelPestampRecord),
      mergeMap(({ postdata }) =>
        this.pestampService.cancelPestampProject(postdata).pipe(
          map(() => cancelPestampRecordSuccess()),
          catchError((error) => of(cancelPestampRecordFailure({ error })))
        )
      ),
    ),
  );

  cancelPestampRecordSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(cancelPestampRecordSuccess),
        tap(() => {
          this.toastifyService.showSuccessMessage(GlobalComponent.messages.cancelsuccess);
        })
      ),
    { dispatch: false }
  );

  cancelPestampRecordFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(cancelPestampRecordFailure),
        tap((error: any) => {
          this.toastifyService.showErrorMessage(error.error.message);
        })
      ),
    { dispatch: false }
  );

  // FETCH ATTACHMENTS OF PESTAMP RECORD
  fetchPestampAttachments$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchPestampAttachments),
      mergeMap(({ jobguid }) =>
        this.pestampService.getPestampsAttachments(jobguid).pipe(
          map((attachments) => fetchPestampAttachmentsSuccess({ attachments })),
          catchError((error) => of(fetchPestampAttachmentsFailure({ error })))
        )
      ),
    ),
  );

  fetchPestampAttachmentsFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fetchPestampAttachmentsFailure),
        tap((error: any) => {
          this.toastifyService.showErrorMessage(error.error.message);
        })
      ),
    { dispatch: false }
  );

  // Create Pestamp Record
  editPestampData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(editPestampData),
      mergeMap(({ postdata, recordId }) =>
        this.pestampService.editPestampsData(postdata, recordId).pipe(
          map((pestamprecord) => editPestampDataSuccess(pestamprecord)),
          catchError((error) => of(editPestampDataFailure({ error })))
        )
      ),
    ),
  );

  editPestampDataSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(editPestampDataSuccess),
        tap((user: any) => {
          this.toastifyService.showSuccessMessage("Order updated successfully");
        })
      ),
    { dispatch: false }
  );

  editPestampDataFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(editPestampDataFailure),
        tap((error: any) => {
          this.toastifyService.showErrorMessage(error.error.message);
        })
      ),
    { dispatch: false }
  );

  /**
   * RELEASE PESTAMP RECORD
   */
  releasePestampRecord$ = createEffect(() =>
    this.actions$.pipe(
      ofType(releasePestampRecord),
      mergeMap(({ recordguid, postdata }) =>
        this.pestampService.releaserecord(recordguid, postdata).pipe(
          map(() => releasePestampRecordSuccess()),
          catchError((error) => of(releasePestampRecordFailure({ error })))
        )
      ),
    ),
  );

  releasePestampRecordSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(releasePestampRecordSuccess),
        tap(() => {
          this.toastifyService.showSuccessMessage("Record released successfully");
          // this.router.navigate(['../']);
        })
      ),
    { dispatch: false }
  );

  releasePestampRecordFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(releasePestampRecordFailure),
        tap((error: any) => {
          console.log('error', error);
          this.toastifyService.showErrorMessage(error.error.message);
        })
      ),
    { dispatch: false }
  );

  // FETCH ATTACHMENTS OF PESTAMP RECORD
  fetchPestampFileAttachment$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchPestampFileAttachment),
      mergeMap(({ jobguid }) =>
        this.pestampService.getPestampFile(jobguid).pipe(
          map((attachments) => fetchPestampFileAttachmentSuccess({ attachments })),
          catchError((error) => of(fetchPestampFileAttachmentFailure({ error })))
        )
      ),
    ),
  );

  fetchPestampFileAttachmentFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fetchPestampFileAttachmentFailure),
        tap((error: any) => {
          this.toastifyService.showErrorMessage(error.error.message);
        })
      ),
    { dispatch: false }
  );

  //REVIEW COMMENT CREATE
  // COMMENT CREATE
  createPestampReviewCommentRecord$ = createEffect(() =>
    this.actions$.pipe(
      ofType(createPestampReviewCommentRecord),
      mergeMap(({ postdata }) =>
        this.commonService.createRecords('pestampcomments', postdata).pipe(
          map((comment) => createPestampReviewCommentRecordSuccess({ comment })),
          catchError((error) => of(createPestampReviewCommentRecordFailure({ error })))
        )
      ),
    ),
  );

  createPestampReviewCommentRecordFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(createPestampReviewCommentRecordFailure),
        tap((error: any) => {
          this.toastifyService.showErrorMessage(error.error.message);
        })
      ),
    { dispatch: false }
  );

  /**
   * REVISION DELETE
   */
  deleteRevisionRecord$ = createEffect(() =>
    this.actions$.pipe(
      ofType(deleteRevisionRecord),
      mergeMap(({ id }) =>
        this.pestampService.deleterevision(id).pipe(
          map(() => deleteRevisionRecordSuccess()),
          catchError((error) => of(deleteRevisionRecordFailure({ error })))
        )
      ),
    ),
  );

  deleteRevisionRecordSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(deleteRevisionRecordSuccess),
        tap(() => {
          this.toastifyService.showSuccessMessage("Revision deleted and moved to delivered successfully");
        })
      ),
    { dispatch: false }
  );

  deleteRevisionRecordFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(deleteRevisionRecordFailure),
        tap((error: any) => {
          console.log('error', error);
          this.toastifyService.showErrorMessage(error.error.message);
        })
      ),
    { dispatch: false }
  );



  constructor(
    private actions$: Actions,
    private afs: AngularFirestore,
    private tokenService: TokenStorageService,
    private pestampService: PestampService,
    private toastifyService: ToastifyService,
    private router: Router,
    private genericService: GenericService,
    private commonService: CommonAPIService,
    private filtersService: FiltersService
  ) {
  }
}